import { render, staticRenderFns } from "./CardIcon.vue?vue&type=template&id=f8e3629e"
import script from "./CardIcon.vue?vue&type=script&lang=ts&setup=true"
export * from "./CardIcon.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports